import {CRUDEntity} from "../abstracts/CRUDEntity";
import {EntityModalForm} from "../abstracts/mixins/EntityModalForm";
import {FormActions} from "../abstracts/mixins/FormActions";
import {HasStatus} from "../abstracts/mixins/HasStatus";

export const CheckList = (() => {

    return class CheckList extends CRUDEntity {

        constructor(id=null) {
            super();
            this.entityClass = 'checklist';
            this.urlRoot = '/jobs-flow/checklist';
            this.sectionRootUrl = '/jobs-flow';
            this.id = id;

            Object.assign(CheckList.prototype, FormActions);
            Object.assign(CheckList.prototype, EntityModalForm);
            Object.assign(CheckList.prototype, HasStatus);


            CheckList.prototype.deleteChecklist = function () {
                const url = `${this.urlRoot}/${this.id}/delete`;
                $.ajax({
                    type: 'DELETE',
                    url: url,
                    success: function (response) {
                        if (response.status == 'success') {
                            window.history.back()
                           //window.location.replace(`${response.redirect_link}`)
                        } else window.location.reload()
                    },
                    error: function (response) {
                        window.location.reload()
                    }
                })

            }


            CheckList.prototype.collectDataInForm = function (formId) {
                let data = {
                    items: [],
                    job_id: $('#job_id').val(),
                    job_type: $('#job_type').val(),
                    service_title: $('#service_title').val()
                }
                if ($('#checklist_id')) data.id = $('.checklist_id').val();
                const items = $(`#${formId} .item`);
                for (let item of items) {
                    const itemJQ = $(item);
                    if (itemJQ.find(`[name=title]`).val().trim().length > 0 && itemJQ.find(`[name=details]`).val().trim().length > 0) {
                        data.items.push({
                            id: itemJQ.find(`[name=item_id]`).val(),
                            title: itemJQ.find(`[name=title]`).val().trim(),
                            details: itemJQ.find(`[name=details]`).val().trim()
                        });
                    }
                }
                return data;
            }

            CheckList.prototype.createChecklist = function () {
                const formId = `create-${this.entityClass}`;
                const data = this.collectDataInForm(formId);
                $.ajax({
                    url: `${this.urlRoot}/create`,
                    method: 'PUT',
                    data: data,
                    success: function (response) {
                        if (response.status === 'success') {
                            if (data.job_type === "appointment") {
                                location.href = '/service-list?entity_class=orders'
                            } else {
                                location.href = '/jobs-flow?entity_class=jobs'
                            }
                        } else window.location.reload()
                    },
                    error: function (response) {
                        window.location.reload()
                    }
                })
            }
                CheckList.prototype.updateChecklist = function (id) {
                    const formId = `edit-${this.entityClass}`;
                    const data = this.collectDataInForm(formId);
                    $.ajax({
                        url: `${this.urlRoot}/${id}/update`,
                        method: 'POST',
                        data: data,
                        success: function (response) {
                            if (response.status == 'success') {
                                window.history.back()
                              //  window.location.replace(`${response.redirect_link}`)
                            } else window.location.reload()
                        },
                        error: function (response) {
                            window.location.reload()
                        }
                    })
                }

        }


        view() {
            $.ajax({
                type: 'GET',
                url: `${this.urlRoot}/${this.id}`,

                success: function (response) {
                    $('#form-container').html(response);
                    $('#checklist-view-modal').modal('show');
                },
                error: function (response) {
                    console.log(response);
                }
            });
        }

        log() {
            $.ajax({
                type: 'GET',
                url: `${this.urlRoot}/${this.id}/log`,

                success: function (response) {
                    $('#sub-container').html(response);
                    $('#checklist-log-modal').modal('show');
                },
                error: function (response) {
                    console.log(response);
                }
            });
        }



    }
})();
